import {
  Vector3,
  type CatmullRomCurve3
} from "three"
import { random } from "../../../core/util/math/Math"

const PARTICLES_PER_CURVE = 1
const PARTICLE_LIFETIME = 7 // seconds

export type WaterCurveParticleData = {
  start: Vector3
  end: Vector3
  mid: Vector3
  offset: number
  lifetime: number
}

export function createWaterCurveParticleDataFromCurves(
  curves: Array<CatmullRomCurve3>,
): Array<WaterCurveParticleData> {
  const particleData: Array<WaterCurveParticleData> = []

  for (const curve of curves) {
    const [p0, p1, p2] = curve.getPoints(2) // start, mid, end
    // const { horz } = curve
    for (let i = 0; i < PARTICLES_PER_CURVE; i++) {
      particleData.push({
        start: p0,
        end: p2,
        mid: p1,
        offset: random() * PARTICLE_LIFETIME * 2, // because half the lifetime is spent invisible
        lifetime: PARTICLE_LIFETIME,
        // horz,
      })
    }
  }

  return particleData
}
